module.exports = __webpack_public_path__ + "static/media/Ecommerce4.c73b15b4.png";